import { html } from "lit";
import type { Meta, StoryObj } from "@storybook/web-components";
import { ProactiveCaseClosureProps } from "../src/components/proactive-case-closure/proactive-case-closure";
import { ProactiveCaseClosureModalProps } from "../src/components/proactive-case-closure/proactive-case-closure-modal";

const meta = {
    title: "Proactive Case Closure",
    component: "mf-proactive-case-closure",
    argTypes: {
        callId: {
            control: { type: "text" }
        },
        locale: {
            options: ["en_US", "de_DE"],
            control: { type: "select" }
        }
    },
    render: (args) =>
        html`<mf-proactive-case-closure .callId=${args.callId} locale="${args.locale}" env="qa"></mf-proactive-case-closure>`
} satisfies Meta<ProactiveCaseClosureProps>;

export default meta;

export const Default: StoryObj<ProactiveCaseClosureProps> = {
    args: {
        callId: "d495e9a6-2f2d-f911-994f-358924b2c06b",
        locale: "en_US"
    }
};

export const Modal: StoryObj<ProactiveCaseClosureModalProps> = {
    args: {
        callId: "d495e9a6-2f2d-f911-994f-358924b2c06b",
        locale: "en_US",
        modalName: "proactive-case-closure"
    },
    render: (args) =>
        html`<div>
            <button data-trigger-modal=${`open,${args.modalName}`}>Open Modal</button>
            <mf-proactive-case-closure-modal
                call-id="${args.callId}"
                locale="${args.locale}"
                modal-name="${args.modalName}"
                env="qa"
            ></mf-proactive-case-closure-modal>
        </div>`
};
